export const VEHICLE_COLORS = [
    'Beige', 'Black', 'Blue', 'Brown', 'Gold', 'Gray', 'Green',
    'Orange', 'Purple', 'Red', 'Silver', 'White', 'Yellow',
];

export type OdometerUnit = 'mi' | 'km';
